var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "generate-vehicle-trip-print"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group1 row"
  }, [_c('div', {
    staticClass: "col-md-2 radio"
  }, [_c('label', [_vm._v("Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-form-fieldset', {
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "Delivery",
      "id": "Delivery",
      "value": "delivery"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "delivery")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "delivery"
      }, _vm.getDeliveryShipments]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "Delivery"
    }
  }, [_vm._v("Delivery")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('b-form-fieldset', {
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedType),
      expression: "checkedType"
    }],
    attrs: {
      "type": "radio",
      "name": "Reverse",
      "id": "Reverse",
      "value": "reverse"
    },
    domProps: {
      "checked": _vm._q(_vm.checkedType, "reverse")
    },
    on: {
      "change": [function($event) {
        _vm.checkedType = "reverse"
      }, _vm.getDeliveryShipments]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle"
  })])]), _c('label', {
    attrs: {
      "for": "Reverse"
    }
  }, [_vm._v("Reverse Pick Up")])])], 1), _vm._v(" "), (_vm.showRefresh == true) ? _c('div', {
    staticClass: "col-md-1 radio"
  }, [_c('b-form-fieldset', {
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "20px",
      "float": "center"
    },
    on: {
      "click": _vm.getDeliveryShipments
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this Pending Inscan Delivery list"
    }
  })])])], 1) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [(_vm.showReverseTable == true) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Client")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total Items")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("PinCode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("City")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Net Payment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Octroi MRP")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reverseShipmentArray), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ClientId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.FinalDestinationID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.TotalItems))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.DropPinCode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShipCity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ServiceType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CollectiableAmount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.DeclareValue))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }), _vm._v(" "), (_vm.showDeliveryTable == true) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Client")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Total Items")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("PinCode")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("City")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Net Payment")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Octroi MRP")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.inScannedShipmentArray), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ClientID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.FinalDestinationID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.TotalItems))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.DropPinCode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.DropCity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ServiceType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.NetShipmentValue))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.DeclaredValue))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 10),
      expression: "totalRows>10"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b387bbc","hasScoped":true}!./src/views/components/HubInscan/ReloadInscanShipmentList/ReloadInscanShipmentList.html
// module id = 1037
// module chunks = 2